export const LOGIN_TOKEN_KEY: string = 'LOGIN_TOKEN';